import React from 'react';
import { Address } from 'src/model/Address';

interface AddressListProps {
  addresses: Address[] | undefined;
  onSelectAddress: (id: string) => void;
  selectedAddress?: string;
}

export const AddressList: React.FC<AddressListProps> = ({
  addresses,
  onSelectAddress,
  selectedAddress,
}) => {
  if (!addresses || addresses.length === 0) {
    return (
      <div className="bg-white border border-gray-200 rounded-lg shadow-sm w-full">
        <div className="px-4 sm:px-6 py-4 border-b border-gray-100">
          <h3 className="text-lg font-semibold text-gray-900">Endereços</h3>
        </div>
        <div className="p-6">
          <p className="text-gray-500 text-center py-8 text-sm">
            Nenhum endereço cadastrado
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow-sm w-full">
      <div className="px-4 sm:px-6 py-4 border-b border-gray-100">
        <h3 className="text-lg font-semibold text-gray-900">Endereços</h3>
      </div>

      <div className="p-4 sm:p-6">
        <div className="space-y-3">
          {addresses.map((address) => (
            <div
              key={address.id}
              onClick={() => onSelectAddress(address.id)}
              className={`p-4 rounded-lg border-2 cursor-pointer transition-all duration-200 ${
                selectedAddress === address.id
                  ? 'border-red-500 bg-red-50 shadow-md'
                  : 'border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50'
              }`}
            >
              <div className="space-y-2">
                <div className="flex items-start justify-between">
                  <h4 className="font-medium text-gray-900 text-sm sm:text-base">
                    {address.street}, {address.number}
                  </h4>
                  {selectedAddress === address.id && (
                    <div className="flex-shrink-0 ml-2">
                      <div className="w-2 h-2 bg-red-500 rounded-full"></div>
                    </div>
                  )}
                </div>

                <p className="text-xs sm:text-sm text-gray-600">
                  {address.district} - {address.city}, {address.state}
                </p>

                <p className="text-xs sm:text-sm text-gray-500">
                  {address.zipcode} - {address.country}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
